import { combineReducers } from 'redux';

import list from './list';
import create from './create';
import details from './details';

export const STATE_ROOT = 'apps';

export interface AppsState {
  details: ReturnType<typeof details>
  list: ReturnType<typeof list>
  permissions: unknown
}

export {
  configureAppsFetch,
} from './list';

export default combineReducers({
  list,
  create,
  details,
});
